(function (ws) {
    'use strict';
    ws.collections.ManualrmaSerialNumbersCollection = Backbone.Collection.extend({
        url: globals.path.api.westcon.rmaSerialNumbers,

        /**
         * Since API returns serial numbers as an array of strings, parse them into object models can understand
         * @param {Object} response
         * @returns {*}
         */
        parse: function (response) {
            return response.map(function (item) {
                return {
                    serialNumber: item
                };
            });
        },

        /**
         * Filter selected serial numbers
         */
        selected: function () {
            return this.where({
                selected: true
            });
        },

        /**
         * search in collection
         */
        search: function (searchTerm) {
            return this.filter(function (model) {
                return model.get('serialNumber').indexOf(searchTerm) !== -1;
            });
        }
    });
}(westcon));
